import { IPayoutInfluencer } from "@shared/lib/types/briefCampains";
import { TextWithTooltip } from "@shared/ui/TextWithTooltip";
import styles from "./styles.module.scss";

type PayoutVendorBillingCellProps = {
  record: IPayoutInfluencer;
};

export function PayoutVendorBillingCell({
  record,
}: PayoutVendorBillingCellProps) {
  const name = record.vendorBilling?.name || "—";
  const contact = [
    record.vendorBilling?.countryCode,
    record.vendorBilling?.phoneNumber,
    record.vendorBilling?.emailId,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.cell}>
      <TextWithTooltip text={name} limit={22} />
      {contact ? (
        <span className={styles.meta}>
          <TextWithTooltip text={contact} limit={24} />
        </span>
      ) : null}
    </div>
  );
}
